import { render, staticRenderFns } from "./publicWelfare_1.vue?vue&type=template&id=0e5ba611"
import script from "./publicWelfare_1.vue?vue&type=script&lang=js"
export * from "./publicWelfare_1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports